import React from 'react'
import DashboardData from 'components/Dashboard/Customer'
import Layout from 'components/LayoutForPortal'
const Dashboard = () => {
    return (
        <Layout>
            <DashboardData />
        </Layout>
    )
}

export default Dashboard;